import React from "react";
import { Input, Switch, Text, Box } from "@showitinc/showit-wc";

import AnimationProperties from "../../../components/AnimationProperties";
import AppConstants from "../../../constants/AppConstants";
import {
  AUTO_ADVANCE_VIEW_TIME,
  STATE_TRANSITION_IN,
  STATE_TRANSITION_OUT,
} from "../../../constants/AnimationConstants";
import { elementSyncUtils } from "../../../utils/SyncUtils";
import { getProp } from "../../../utils/Merge/MergeUtils.mjs";
import LeftOffset from "../../../components/base/LeftOffset";
import SplitMergeWrapper from "../../base/SplitMergeWrapper";
import When from "../../../components/utils/When";
import { formatPropUpdate } from "../../../utils/PropertyUtils";
import { INPUT_TYPE_NUMBER } from "../../../constants/ElementConstants";

import { initFormatter } from "../../../utils/PropertyFormatters";

const { ANIMATION_TYPE_FADE, DEFAULT_AUTO_ADVANCE_TIME } = AppConstants;

const AutoAdvanceInputs = ({ block, layout, onChange }) => {
  const _onAdvanceCheckChange = (propInfo) => {
    propInfo.value = propInfo.value ? DEFAULT_AUTO_ADVANCE_TIME : null;
    onChange(propInfo);
  };

  const { isSynced, toggleSyncedProp, getPropName } = elementSyncUtils(
    block,
    _onAdvanceCheckChange,
    layout
  );

  const { onChange: onChangeValue } = initFormatter(onChange, getPropName);


  const aav = getProp(block, layout, AUTO_ADVANCE_VIEW_TIME);
  const aavSynced = isSynced(AUTO_ADVANCE_VIEW_TIME);

  const aavInputs = (
    <Box pb="1">
      <Switch
        label="Auto Advance View"
        checked={aav !== undefined}
        propName={getPropName(AUTO_ADVANCE_VIEW_TIME)}
        context
        onClick={(e) =>
          _onAdvanceCheckChange(
            formatPropUpdate(getPropName(AUTO_ADVANCE_VIEW_TIME), e.target.checked, aav)
          )
        }
      />
      <When it={aav !== undefined}>
        <LeftOffset>
          <Input
            label="Time"
            type={INPUT_TYPE_NUMBER}
            min="0"
            step="0.25"
            value={aav}
            units="sec"
            onSIInput={onChangeValue(AUTO_ADVANCE_VIEW_TIME,false)}
            onSIBeforeChange={onChangeValue(AUTO_ADVANCE_VIEW_TIME)}
            onSIChange={onChangeValue(AUTO_ADVANCE_VIEW_TIME)}            
          />
        </LeftOffset>
      </When>
    </Box>
  );

  return (
    <Box mb="1">
      <SplitMergeWrapper
        layout={layout}
        sync={aavSynced}
        toggleSync={() => toggleSyncedProp(AUTO_ADVANCE_VIEW_TIME)}
      >
        {aavInputs}
      </SplitMergeWrapper>
    </Box>
  );
};

const BlockPropertiesStateAnimation = ({ block, layout, onPropUpdate }) => {
  const _onAnimationChange = (propInfo) => {
    onPropUpdate && onPropUpdate(propInfo);
  };

  const blockProps = block.get(layout);
  const stateTrIn = blockProps.get(STATE_TRANSITION_IN);
  const stateTrOut = blockProps.get(STATE_TRANSITION_OUT);

  return (
    <>
      <AutoAdvanceInputs block={block} layout={layout} onChange={_onAnimationChange} />
      <Text className="panel-subheading">Canvas View In</Text>
      <AnimationProperties
        container={block}
        layout={layout}
        transitionType={STATE_TRANSITION_IN}
        tran={stateTrIn}
        propPrefix={layout}
        showBlockDefault={false}
        defaultType={ANIMATION_TYPE_FADE}
        onPropUpdate={_onAnimationChange}
      />
      <Text className="panel-subheading">Canvas View Out</Text>
      <AnimationProperties
        container={block}
        layout={layout}
        transitionType={STATE_TRANSITION_OUT}
        tran={stateTrOut}
        propPrefix={layout}
        showBlockDefault={false}
        defaultType={ANIMATION_TYPE_FADE}
        onPropUpdate={_onAnimationChange}
      />
    </>
  );
};

export default BlockPropertiesStateAnimation;
